import { type TimelineItemContext } from 'src/modules/communications/hooks/timeline/timeline-item-context';

/**
 * Returns a Tailwind border color class to visually indicate cross-context items.
 *
 * - No class when not cross-context or while loading context.
 * - Uses 'border-neutral-300' for archived conversations.
 * - Uses 'border-info-300' when cross-context and not archived.
 */
export function getContextBorderTintClass(
  context?: TimelineItemContext
): string {
  if (!context) return '';

  const hasCrossContext = !!context.otherFunnel || !!context.otherConversation;
  if (!hasCrossContext) return '';

  const isArchived = !!context.otherConversation?.archivedAt;
  return isArchived ? 'border-neutral-200' : 'border-info-200';
}

/**
 * Returns a Tailwind opacity class to subtly de-emphasize cross-context items.
 *
 * - No class when not cross-context.
 * - Uses lower opacity for archived items.
 */
export function getContextOpacityClass(context?: TimelineItemContext): string {
  if (!context) return '';

  const hasCrossContext = !!context.otherFunnel || !!context.otherConversation;
  if (!hasCrossContext) return '';

  return 'opacity-80 hover:opacity-100';
}
